module.exports = __webpack_public_path__ + "img/behold-13.9e4c8184.png";